import { Fragment } from 'react';

import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Divider from 'src/components/ResumeCard/Divider';
import translation from 'src/components/translation';
import type { ResumeCardData } from 'src/models/resumeCard';

import CollapseText from 'src/components/ResumeCard/Body/Collapse/Text';
import Field from 'src/components/ResumeCard/Body/Field';

const TrlKeys = {
    title: 'resume.search.field.keySkills',
};

const KeySkills: TranslatedComponent<{ resume: ResumeCardData }> = ({ resume, trls }) => {
    const totalExperience = resume.totalExperience?.[0]?.string;
    const keySkills = resume.keySkills;
    if (totalExperience !== 0 || !keySkills?.length) {
        return null;
    }

    return (
        <Field title={trls[TrlKeys.title]} dataQaName="key-skills">
            <CollapseText dataQa="key-skills">
                {keySkills.map(({ string: text }, index) => (
                    <Fragment key={text}>
                        {index !== 0 && <Divider />}
                        {text}
                    </Fragment>
                ))}
            </CollapseText>
        </Field>
    );
};

export default translation(KeySkills);
